import React from 'react';
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import { UploaderRoute, AuthorRoute, ManagerRoute, ParentRoute } from './DashboardRouter_util';
import Portal from './Portal/Portal';
import HomePage from './Home/HomePage';
import WorkInstructionsPageContainer from './Work Instructions/work_instructions_page_container';
import WorkInstructionPageContainerLite from './Work Instructions/work_instructions_page_container_lite';
// import WIAuthorContainer from './Work Instructions/Author/wi_author_container';
import WIPreviewContainer from './Work Instructions/Preview/wi_preview_container';
import ModelUploaderContainer from './Model Uploader/model_uploader_container';
import FeedbackContainer from './Feedback/feedback_container';
import DeviceManagementPage from './Management/Device/device_management_page_container';
import UserManagementPage from './Management/User/user_management_page_container';
import WIAuthorParent from './Work Instructions/Author/WIAuthorParent';
import WIAuthorLite from './Work Instructions/Author/WIAuthorLite';
import Settings from './Settings/Settings';
import FAQ from './FAQ/FAQ';
import NotFoundPage from "../Templates/NotFoundPage";
import PrimaryHeaderContainer from '../Templates/primary_header_container';
import { AppFooter } from '../Dashboard/Footer/Footer';
import AttachmentLibrary from '../Dashboard/Work Instructions/Author/Attachments/attachments_library_container';
import ChatButton from './Work Instructions/Author/ChatButton';

const DashboardRouter = ({ role }) => {
    // Determine default route based on role
    let defaultRoute = '/dashboard/home';
    if(role === 'Artisan'){
       defaultRoute = '/dashboard/model viewer';
    }
    // Add additional role checks as needed

    return (
        <div id="dashboard-container" className="flex-column">
            <PrimaryHeaderContainer />
            <div className="flex max-width" style={{flex: '1 1 auto', minHeight: 0}}>
                <Portal />
                <div id="view-window">
                    <Switch>
                        {/* If user navigates to /dashboard with no additional path, redirect based on their role */}
                        <Route exact path="/dashboard" render={() => <Redirect to={defaultRoute} />} />
                        <Route path="/dashboard/home" component={HomePage} />
                        <Route exact path="/dashboard/work instructions parent" component={WorkInstructionsPageContainer} />
                        <Route exact path="/dashboard/model viewer" render={props => <WorkInstructionPageContainerLite {...props} role={role} />} />
                        <ParentRoute path="/dashboard/work instructions parent/:WIID" component={WIAuthorParent} />
                        <Route path="/dashboard/model viewer/:id" component={WIAuthorLite} />
                        <UploaderRoute path="/dashboard/model uploader" component={ModelUploaderContainer} />
                        <Route path="/dashboard/attachment library" render={props => <AttachmentLibrary {...props} isAll={true} />} />
                        <Route path="/dashboard/feedback" component={FeedbackContainer} />
                        <ManagerRoute path="/dashboard/management/users" component={UserManagementPage} />
                        {/* <ManagerRoute path="/dashboard/management/devices" component={DeviceManagementPage} /> */}
                        <Route path="/dashboard/settings" component={Settings} />
                        <Route path="/dashboard/faq" component={FAQ} />
                        <Route render={() => <NotFoundPage />} />
                    </Switch>
                    <FooterWithChat />
                </div>
            </div>
        </div>
    );
}

const FooterWithChat = () => {
    const location = useLocation();
    // Extract WIID from route if available - only show chat button on WIAuthorParent page
    const pathMatch = location.pathname.match(/\/dashboard\/work instructions parent\/([^\/]+)/);
    const wipId = pathMatch ? pathMatch[1] : null;
    const isWIAuthorParentPage = !!pathMatch;

    return (
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: isWIAuthorParentPage ? 'space-between' : 'flex-start',
            width: '96%',
            margin: '0 .65em 0 1em',
            marginTop: 'auto',
            // paddingTop: '15px',
            paddingBottom: '15px'
        }}>
            <AppFooter />
            {isWIAuthorParentPage && <ChatButton wipId={wipId} />}
        </div>
    );
}

const mapStateToProps = state => ({
    role: state.session.user ? state.session.user.role : undefined
});

export default connect(mapStateToProps)(DashboardRouter);